import styled from 'styled-components';
import { node, string, func } from 'prop-types';

const Button = styled.button`
  border-radius: 6px;
  border: none;
  cursor: pointer;
  display: block;
  margin: ${({ margin }) => (margin ? margin : 'initial')};
  padding: 16px 32px;
  background: ${({ background }) => (background ? background : 'inherit')};
`;

const StyledButton = ({ children, margin, background, onClick }) => (
  <Button margin={margin} background={background} onClick={onClick}>
    {children}
  </Button>
);

StyledButton.propTypes = {
  children: node.isRequired,
  background: string,
  margin: string,
  onClick: func,
};

export default StyledButton;



// WEBPACK FOOTER //
// components/shared/StyledButton.js